import React, { Component } from 'react';

class Menu extends Component {

	constructor(props) {
		super(props);

		this.itens = [
			{
				nome: "Enviar Arquivos",
				title: "enviar-arquivos",
				path: "#",
				ico: "ecoico ecoico-upload-arquivos"
			},
			{
				nome: "Parâmetros de Validação",
				title: "parametros-auditoria",
				path: "/parametros-auditoria",
				ico: "ecoico ecoico-parametros"
			},
			{
				nome: "Arquivos Recentes",
				title: "arquivos-recentes",
				path: "/arquivos-recentes",
				ico: "ecoico ecoico-arquivos"
			},
			{
				nome: "Histórico",
				title: "historicoResultado",
				path: "/historicoResultado",
				ico: "ecoico ecoico-historico"
			}
		];

		this.itensAdministrativos = [
			{
				nome: "Simular Acesso",
				title: "Acessar a simulação de acesso",
				path: "/simular-acesso",
				ico: "fas fa-desktop"
			}
		];
	};

	get Itens() {
		return this.itens;
	};
	get ItensAdministrativos() {
		return this.itensAdministrativos;
	};
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Layout/Menu.js